import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface EditModeState {
  active: boolean;
  expiresAt: number | null;
}

const initialState: EditModeState = { active: false, expiresAt: null };

const slice = createSlice({
  name: 'editMode',
  initialState,
  reducers: {
    setEditModeStatus(state, action: PayloadAction<{ active: boolean; expiresAt: number | null }>) {
      state.active = action.payload.active;
      state.expiresAt = action.payload.expiresAt;
    },
    clearEditMode(state) {
      state.active = false;
      state.expiresAt = null;
    },
  },
});

export const { setEditModeStatus, clearEditMode } = slice.actions;
export const editModeReducer = slice.reducer;
